import Dashboard from './pages/Dashboard'
import MessageVerify from './pages/MessageVerify/MessageVerify'
import Login from './pages/Login/Login'
import Register from './pages/Register/Register'
import ResetPassword from './pages/resetPassword/ResetPassword'
import Authorize from './pages/Authorize'

const routes = [
  {
    path: '/',
    component: Dashboard
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/register',
    component: Register
  },
  {
    path: '/register/smsverification',
    component: MessageVerify
  },
  {
    path: '/forgetPassword',
    component: MessageVerify
  },
  {
    path: '/forgetPassword/resetPassword',
    component: ResetPassword
  },
  {
    path: '/authorize',
    component: Authorize
  }
]
export default routes
